import React, { useRef, useState, useEffect } from 'react';

import { AppLayout } from '../components/Layout';
import Grid from '@amzn/awsui-components-react/polaris/grid';

import '@amzn/awsui-global-styles/dark-mode-utils.css';
import '../styles/base.scss';

import { BreadcrumbGroup } from '@amzn/awsui-components-react';
import { statsBreadcrumbs } from './uploadfilescommon/breadcrumbs';

import { BaseStaticWidget } from './statswidgets/base-static-widget';



import { PieChart } from '@amzn/awsui-components-react';

import { percentageFormatter } from './statswidgets/chart-commons';

import { Box, Header, ColumnLayout } from '@amzn/awsui-components-react';
import { WidgetConfig } from './statswidgets/interfaces';

import { API, GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { Analytics, Auth } from "aws-amplify";

import { projectTitle } from '../constants';
import { captionCornerStatsModelsByUsername, listCaptionCornerStatsModels } from '../graphql/queries';



Analytics.autoTrack('pageView', {
    // REQUIRED, turn on/off the auto tracking
    enable: true,
    // OPTIONAL, the event name, by default is 'pageView'
    eventName: 'StatsPage',
    type: 'SPA',
    getUrl: () => {
        // the default function
        return window.location.origin + window.location.pathname;
    }
});


const costSavings: WidgetConfig = {
    definition: { defaultRowSpan: 2, defaultColumnSpan: 1 },
    data: {
        icon: 'list',
        title: 'Cost Savings',
        description: 'Your Cost Savings',
        header: CostSavingsHeader,
        content: CostSavingsContent,
    },
};

function CostSavingsHeader() {
    return (
        <Header variant="h2" description="What you've done">
            Your Stats
        </Header>
    );
}

function CostSavingsContent() {
    const [costSavingsTotalAmount, setCostSavingsTotalAmount] = useState(0);
    const [filesProcessedUserTotal, setFilesProcessedUserTotal] = useState(0);

    useEffect(() => {
        getFromDDB();
    }, [])

    async function getFromDDB() {
        try {
            // Get the User
            var email = "";
            await Auth.currentAuthenticatedUser().then((user) => email = user.attributes.email);

            const emailsplit = email.split("@");
            const allCaptionCornerStatsModels = await API.graphql({
                query: listCaptionCornerStatsModels,
                variables: {
                    filter: {
                        username: {
                            eq: emailsplit[0]
                        }
                    }
                }
            });
            
            console.log("API Response:", JSON.stringify(allCaptionCornerStatsModels, null, 2));
            
            if (allCaptionCornerStatsModels.data && 
                allCaptionCornerStatsModels.data.listCaptionCornerStatsModels && 
                allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items && 
                allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items.length > 0) {
                
                setFilesProcessedUserTotal(allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items[0].totalFiles);
                setCostSavingsTotalAmount(allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items[0].totalCostSavings);
            } else {
                console.log("No data found for user:", emailsplit[0]);
                setFilesProcessedUserTotal(0);
                setCostSavingsTotalAmount(0);
            }
        } catch (error) {
            console.error("Error in getFromDDB:", error);
            setFilesProcessedUserTotal(0);
            setCostSavingsTotalAmount(0);
        }
    }
    return (
        <>
            <ColumnLayout columns={2} variant="text-grid" minColumnWidth={10}>
                <div>
                    <Box variant="awsui-key-label">Cost Savings</Box>
                    <Box color="text-status-success" fontSize="display-l" fontWeight="bold" >
                        ${Number(costSavingsTotalAmount).toFixed(2)}
                    </Box>
                </div>
                <div>
                    <Box variant="awsui-key-label">Files Processed</Box>
                    <Box color="text-status-info" fontSize="display-l" fontWeight="bold" >
                        {filesProcessedUserTotal}
                    </Box>
                </div>
            </ColumnLayout>
            <br />
            <Box textAlign="center">
                Based on a cost of $2 per minute
            </Box>
        </>
    );
}

const Breadcrumbs = () => (
    <BreadcrumbGroup items={statsBreadcrumbs} expandAriaLabel="Show path" ariaLabel="Breadcrumbs" />
);

const statsOverview: WidgetConfig = {
    definition: { defaultRowSpan: 2, defaultColumnSpan: 3 },
    data: {
        icon: 'list',
        title: 'Stats overview',
        description: 'Overview of Caption Corner',
        header: StatsOverviewHeader,
        content: StatsOverviewWidget,
    },
};

function StatsOverviewHeader() {
    return (
        <Header variant="h2" description="Global Stats">
            {projectTitle} Overview
        </Header>
    );
}

function StatsOverviewWidget() {
    const [globalFilesProcessed, setGlobalFilesProcessed] = useState(0);
    const [globalCostSavings, setGlobalCostSavings] = useState(0);
    const [globalUsers, setGlobalUsers] = useState(0);

    useEffect(() => {
        getTotalFilesProcessedFromDDB();
        // getTotalUsers();

    }, [])


    async function getTotalFilesProcessedFromDDB() {
        try {
            const allCaptionCornerStatsModels = await API.graphql({
                query: listCaptionCornerStatsModels
            });
            
            console.log("Global stats API response:", JSON.stringify(allCaptionCornerStatsModels, null, 2));

            var GlobalFilesProcessed = 0;
            var GlobalCostSavings = 0;
            var userCount = 0;
            
            // Check if data exists and has the expected structure
            if (allCaptionCornerStatsModels.data && 
                allCaptionCornerStatsModels.data.listCaptionCornerStatsModels && 
                allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items) {
                
                userCount = allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items.length;
                
                //One loop to calculate GlobalFilesProcessed GlobalCostSavings
                for (var i = 0; i < userCount; i++) {
                    const item = allCaptionCornerStatsModels.data.listCaptionCornerStatsModels.items[i];
                    if (item.totalCostSavings) {
                        GlobalCostSavings += item.totalCostSavings;
                    }
                    if (item.totalFiles) {
                        GlobalFilesProcessed += item.totalFiles;
                    }
                }
            }
        
            setGlobalFilesProcessed(GlobalFilesProcessed);
            setGlobalCostSavings(GlobalCostSavings);
            setGlobalUsers(userCount);
        } catch (error) {
            console.error("Error in getTotalFilesProcessedFromDDB:", error);
            setGlobalFilesProcessed(0);
            setGlobalCostSavings(0);
            setGlobalUsers(0);
        }
    }

    return (
        <ColumnLayout columns={3} variant="text-grid" minColumnWidth={170}>
            <div>
                <Box variant="awsui-key-label">Global cost savings</Box>
                <Box color="text-status-success" fontSize="display-l" fontWeight="bold" >
                    ${Number(globalCostSavings).toFixed(2)}
                </Box>
            </div>
            <div>
                <Box variant="awsui-key-label">Global files processed</Box>
                <Box color="text-status-info" fontSize="display-l" fontWeight="bold" >
                    {globalFilesProcessed}
                </Box>
            </div>
            <div>
                <Box variant="awsui-key-label">Global website users</Box>
                <Box color="text-status-info" fontSize="display-l" fontWeight="bold" >
                    {globalUsers}
                </Box>
            </div>
           
        </ColumnLayout>
    );
}

const typesOfFiles: WidgetConfig = {
    definition: { defaultRowSpan: 4, defaultColumnSpan: 2, minRowSpan: 3 },
    data: {
        icon: 'pieChart',
        title: 'Files Processed',
        description: 'Types of files',
        header: TypesOfFilesHeader,
        content: TypesOfFilesContent,
        staticMinHeight: 450,
    },
};

function TypesOfFilesHeader() {
    return (
        <Header variant="h2">
            Your Processed Files
        </Header>
    );
}

function TypesOfFilesContent() {

    const [filesProcessedMP4s, setFilesProcessedMP4s] = useState(0);
    const [filesProcessedMP3s, setFilesProcessedMP3s] = useState(0);
    const [filesProcessedWavs, setFilesProcessedWavs] = useState(0);
    const [filesProcessedFlacs, setFilesProcessedFlacs] = useState(0);
    const [filesProcessedOggs, setFilesProcessedOggs] = useState(0);
    const [filesProcessedAmrs, setFilesProcessedAmrs] = useState(0);
    const [filesProcessedWebms, setFilesProcessedWebms] = useState(0);
    const [filesProcessedM4As, setFilesProcessedM4As] = useState(0);
    const [filesProcessedAACs, setFilesProcessedAACs] = useState(0);


    useEffect(() => {
        getFilesProcessed();
    }, [])

    async function getFilesProcessed() {
        try {
            var email = "";
            await Auth.currentAuthenticatedUser().then((user) => email = user.attributes.email);
            const emailsplit = email.split("@");

            console.log("Getting files processed for user:", emailsplit[0]);
            
            // Check if the DDB entry for the user exists in the Stats table. If not create it.
            const allCaptionCornerStatsModels = await API.graphql({
                query: captionCornerStatsModelsByUsername,
                variables: {
                    username: emailsplit[0]
                }
            });
            
            console.log("Files processed API response:", JSON.stringify(allCaptionCornerStatsModels, null, 2));
            
            if (allCaptionCornerStatsModels.data && 
                allCaptionCornerStatsModels.data.captionCornerStatsModelsByUsername && 
                allCaptionCornerStatsModels.data.captionCornerStatsModelsByUsername.items && 
                allCaptionCornerStatsModels.data.captionCornerStatsModelsByUsername.items.length > 0) {
                
                const stats = allCaptionCornerStatsModels.data.captionCornerStatsModelsByUsername.items[0];
                setFilesProcessedMP4s(stats.totalmp4 || 0);
                setFilesProcessedMP3s(stats.totalmp3 || 0);
                setFilesProcessedWavs(stats.totalwav || 0);
                setFilesProcessedFlacs(stats.totalflac || 0);
                setFilesProcessedOggs(stats.totalogg || 0);
                setFilesProcessedAmrs(stats.totalamr || 0);
                setFilesProcessedWebms(stats.totalwebm || 0);
                setFilesProcessedM4As(stats.totalm4a || 0);
                setFilesProcessedAACs(stats.totalaac || 0);
            } else {
                console.log("No file stats data found for user:", emailsplit[0]);
                // Set all values to 0
                setFilesProcessedMP4s(0);
                setFilesProcessedMP3s(0);
                setFilesProcessedWavs(0);
                setFilesProcessedFlacs(0);
                setFilesProcessedOggs(0);
                setFilesProcessedAmrs(0);
                setFilesProcessedWebms(0);
                setFilesProcessedM4As(0);
                setFilesProcessedAACs(0);
            }
        } catch (error) {
            console.error("Error in getFilesProcessed:", error);
            // Set all values to 0 on error
            setFilesProcessedMP4s(0);
            setFilesProcessedMP3s(0);
            setFilesProcessedWavs(0);
            setFilesProcessedFlacs(0);
            setFilesProcessedOggs(0);
            setFilesProcessedAmrs(0);
            setFilesProcessedWebms(0);
            setFilesProcessedM4As(0);
            setFilesProcessedAACs(0);
        }
        
    }
    return (
        <PieChart
            hideFilter={true}
            //fitHeight={true}
            size="small"
            data={[
                { title: 'MP4', value: filesProcessedMP4s },
                { title: 'MP3', value: filesProcessedMP3s },
                { title: 'WAV', value: filesProcessedWavs },
                { title: 'FLAC', value: filesProcessedFlacs },
                { title: 'OGG', value: filesProcessedOggs },
                { title: 'AMR', value: filesProcessedAmrs },
                { title: 'WEBM', value: filesProcessedWebms },
                { title: 'M4A', value: filesProcessedM4As },
                { title: 'AAC', value: filesProcessedAACs },
            ]}
            ariaLabel="Files Processed chart"
            ariaDescription="Pie chart summarizing the file types processed"
            segmentDescription={(datum, sum) => datum.value + (datum.value == 1 ? ' file' : ' files') + ', ' + percentageFormatter(datum.value / sum)}
            detailPopoverContent={(datum, sum) => [
                {
                    key: 'Files Processed',
                    value: datum.value,
                },
                {
                    key: 'Percentage',
                    value: percentageFormatter(datum.value / sum),
                },
            ]}
       
        />
    );
}


function Content() {
    return (
        <div className="content-wrapper">
            <Grid
                gridDefinition={[
                    { colspan: { l: 4, m: 4, default: 12 } },
                    { colspan: { l: 8, m: 8, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 6, m: 6, default: 12 } },
                    { colspan: { l: 8, m: 8, default: 12 } },
                    { colspan: { l: 4, m: 4, default: 12 } },
                ]}
            >
                {[
                    costSavings,
                    statsOverview,
                    typesOfFiles,
                ].map((widget, index) => (
                    <BaseStaticWidget key={index} config={widget.data} />
                ))}
            </Grid>
        </div>
    );
}

const StatsPage: React.FC = () => {
    
    return (
       <AppLayout 
         content={<Content />}
         breadcrumbs={statsBreadcrumbs}
       />
    );
};  


export { StatsPage };
